import React, { useEffect, useState } from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Campaign } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import "./SocialManagementNodeGroup.css";

export default function SocialManagementNodeGroup(props) {

    const navigate = useNavigate();
    const state = useLocation();
    const [active, setActive] = useState();

    useEffect(() => {
        const activeItemId = state && state.state && state.state.activeItemId;
        if(activeItemId) {
            setActive(activeItemId);
        }
    },[state]);

    return (
        <List component="div" disablePadding>
            <ListItemButton id="5001"
                className={(active === 5001) ? "kmc-console-socialmanagement-litem-active" : ""}
                onClick={() => {
                    navigate('/manage/announcements', { state: { isSocialManagementNodeExpand: true } });
                    setActive(5001);
                }
                }>
                <ListItemIcon>
                    <Campaign fontSize='medium' />
                </ListItemIcon>
                <ListItemText primary={'Manage Announcements'} />
            </ListItemButton>
        </List>
    )
}